import { render, staticRenderFns } from "./PromoBanner.vue?vue&type=template&id=14926659&scoped=true"
import script from "./PromoBanner.vue?vue&type=script&lang=js"
export * from "./PromoBanner.vue?vue&type=script&lang=js"
import style0 from "./PromoBanner.vue?vue&type=style&index=0&id=14926659&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14926659",
  null
  
)

export default component.exports